import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readByEmisor: _idEmisor =>
    api
      .send({
        query: gql`
          query READ_BY_EMISOR($_idEmisor: ID!) {
            Plan {
              readByEmisor(_idEmisor: $_idEmisor) {
                _id
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })

      .then(result => result.data.data.Plan.readByEmisor)
}
